import axios from "~/plugins/axios";
import { DateFormatEnum } from "../enums";

const moment = require("moment");

export default {
  paginateByCustomer(customerId, page = 1, perPage = 20, includes = []) {
    return axios.get(`/web_api/v1/customer_property/by_customer/${customerId}`, {
      params: {
        page,
        perPage,
        include: includes,
      },
    }).then((response) => response.data);
  },
  paginateByProperty(propertyId, page = 1, perPage = 20, includes = []) {
    return axios.get(`/web_api/v1/customer_property/by_property/${propertyId}`, {
      params: {
        page,
        perPage,
        include: includes,
      },
    }).then((response) => response.data);
  },
  getById(customerPropertyId, includes = []) {
    return axios.get(`/web_api/v1/customer_property/${customerPropertyId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
  findByCustomerAndProperty(customerId, propertyId) {
    return axios.post("/web_api/v1/customer_property/by_customer_and_property", {
      customer_id: customerId,
      property_id: propertyId,
    }).then((response) => response.data);
  },
  findByCustomerAndPropertyAndAddressType(customerId, propertyId, addressType, includes = []) {
    return axios.post("/web_api/v1/customer_property/by_customer_and_property_and_address_type", {
      customer_id: customerId,
      property_id: propertyId,
      address_type: addressType,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  findCurrentByCustomerAndAddressType(customerId, addressType, includes = []) {
    return axios.post("/web_api/v1/customer_property/current_by_customer_and_address_type", {
      customer_id: customerId,
      address_type: addressType,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  findAllCurrentByCustomer(customerId, includes = []) {
    return axios.get(`/web_api/v1/customer_property/by_customer/${customerId}/current`, {
      customer_id: customerId,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  create(customerProperty, createAdditionalTypes = [], copyToPartner = false,
    partnerOwnerPercentage = null) {
    const data = customerProperty;

    data.create_additional_types = createAdditionalTypes;
    data.copy_to_partner = copyToPartner;
    data.partner_owner_percentage = partnerOwnerPercentage;

    return axios.post("/web_api/v1/customer_property", data).then((response) => response.data);
  },
  createAsCurrent(customerProperty, createAdditionalTypes = [], copyToPartner = false,
    partnerOwnerPercentage = null) {
    const data = customerProperty;

    data.create_additional_types = createAdditionalTypes;
    data.copy_to_partner = copyToPartner;
    data.partner_owner_percentage = partnerOwnerPercentage;

    return axios.post("/web_api/v1/customer_property/current", data).then((response) => response.data);
  },
  update(customerProperty) {
    const data = { ...customerProperty };

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(data)) {
      if (moment.isMoment(value)) {
        data[key] = value.format(DateFormatEnum.ISO8601);
      }
    }

    return axios.put(`/web_api/v1/customer_property/${customerProperty.id}`, data).then((response) => response.data);
  },
  delete(customerPropertyId) {
    return axios.delete(`/web_api/v1/customer_property/${customerPropertyId}`).then((response) => response.data);
  },
  findOrCreateByCustomerAndPropertyAndAddressType(customerId, propertyId, addressType) {
    return axios.post("/web_api/v1/customer_property/find_or_create_by_customer_and_property_and_address_type", {
      customer_id: customerId,
      property_id: propertyId,
      address_type: addressType,
    }).then((response) => response.data);
  },
  checkIfExistsByCustomerAndPropertyAndAddressType(customerId, propertyId, addressType) {
    return axios.post("/web_api/v1/customer_property/check_if_exists_by_customer_and_property_and_address_type", {
      customer_id: customerId,
      property_id: propertyId,
      address_type: addressType,
    }).then((response) => response.data);
  },
  findOrCreateCurrentByCustomerAndPropertyAndAddressType(customerId, propertyId, addressType) {
    return axios.post("/web_api/v1/customer_property/find_or_create_current_by_customer_and_property_and_address_type", {
      customer_id: customerId,
      property_id: propertyId,
      address_type: addressType,
    }).then((response) => response.data);
  },
  getTemplateByCustomerAndPropertyAndAddressType(customerId, propertyId, addressType) {
    return axios.post("/web_api/v1/customer_property/get_template_by_customer_and_property_and_address_type", {
      customer_id: customerId,
      property_id: propertyId,
      address_type: addressType,
    }).then((response) => response.data);
  },
  copyFromCustomerToCustomer(
    fromCustomerId,
    toCustomerId,
    addressType,
    coOwner = false,
    includes = [],
  ) {
    return axios.post("/web_api/v1/customer_property/copy_from_customer_to_customer", {
      from_customer_id: fromCustomerId,
      to_customer_id: toCustomerId,
      address_type: addressType,
      co_owner: coOwner,
    }, { params: { include: includes } }).then((response) => response.data);
  },
  setCurrent(customerProperty, createAdditionalTypes = [], copyToPartner = false,
    partnerOwnerPercentage = null) {
    return axios.post("/web_api/v1/customer_property/set_current", {
      customer_property_id: customerProperty.id,
      create_additional_types: createAdditionalTypes,
      copy_to_partner: copyToPartner,
      partner_owner_percentage: partnerOwnerPercentage,
    }).then((response) => response.data);
  },
  setCurrentFromTypeToTypeByCustomer(customerId, fromAddressType, toAddressType) {
    return axios.post("/web_api/v1/customer_property/set_current_from_type_to_type_by_customer", {
      customer_id: customerId,
      from_address_type: fromAddressType,
      to_address_type: toAddressType,
    });
  },
  unsetCurrentByTypeForCustomer(customerId, addressType) {
    return axios.post("/web_api/v1/customer_property/unset_current_by_type_for_customer", {
      customer_id: customerId,
      address_type: addressType,
    });
  },
  storeCustomerPropertyAsType(customerPropertyId, customerId, addressType, isCurrent) {
    return axios.post(`/web_api/v1/customer_property/${customerPropertyId}/copy_to_customer`, {
      customer_property_id: customerPropertyId,
      customer_id: customerId,
      address_type: addressType,
      is_current: isCurrent,
    });
  },
  createAsFutureByMortgage(customerId, mortgageId) {
    return axios.post("/web_api/v1/customer_property/create_as_future_by_mortgage", {
      customer_id: customerId,
      mortgage_id: mortgageId,
    }).then((response) => response.data);
  },
};
